import React, { useState, useEffect ,useRef} from 'react';
import { Col, Row, Nav } from 'react-bootstrap';
import { Rolewisetracking,ReportDashBoardd } from './';


function AllReports() {
    const [currentTab, setCurrentTab] = useState('dashboard');//useState('rolewisetracking');//
    const [showSidebar, setShowSidebar] = useState(false);
    const timeoutRef = useRef();
    // useEffect(() => {
    //     timeoutRef.current = setTimeout(() => {
    //         setShowSidebar(false);
    //     }, 3000);
    // }, []);
    const toggleSidebar = () => {
        clearTimeout(timeoutRef.current);
        setShowSidebar(!showSidebar);
    }
    return (
        <Col md={12} sm={12} className='justify-content-center' style={{ position: 'relative' }}>
            <span className={showSidebar ? 'hide-menu' : 'show-menu'} onClick={toggleSidebar}><i className={`fa ${showSidebar ? 'fa-angle-double-left' : 'fa-angle-double-right'}`}></i></span>
            <Row>
                {showSidebar && (<Col md={2} sm={12} className='left-menu-panel'>
                    <Nav className="flex-column border-bottom">
                        <small className='left-menu-hd'><i className="fa fa-line-chart"></i> REPORTS</small>
                         <Nav.Link eventKey="dashboard" onClick={() => setCurrentTab('dashboard')} className={`left-menu-links ${currentTab === 'dashboard' ? 'active' : ''}`}>Dashboard</Nav.Link>
                        <Nav.Link eventKey="rolewisetracking" onClick={() => setCurrentTab('rolewisetracking')} className={`left-menu-links ${currentTab === 'rolewisetracking' ? 'active' : ''}`}>  User's Learning Tracking</Nav.Link>
                       
                    </Nav>
                    {/* <Nav className="flex-column border-bottom">
                        <small className='left-menu-hd'><i className="fa fa-bar-chart"></i> CHARTS</small>
                        <Nav.Link className='left-menu-links'>User's Statewise Analytics</Nav.Link>
                    </Nav> */}
                </Col>
                )}
                <Col md={showSidebar ? "10" : "-12"} sm={12} style={{ minHeight: '100vh' }}>
                    {currentTab === 'dashboard' && <ReportDashBoardd />}
                    {currentTab === 'rolewisetracking' && <Rolewisetracking />}
                    {/* {currentTab === 'config-management' && <ConfigManagement />} */}
                </Col>
            </Row>
        </Col>
    );
}

export default AllReports;